import { Operation } from "@apollo/client";

import { createServiceBaseUrl } from "./createServiceBaseUrl";

export const getServiceBaseUrl = (operation: Operation) => {
  // Always query from non-regional endpoint.
  if (operation.operationName === "GetAriaIngestionKey") {
    return createServiceBaseUrl();
  }

  return (
    sessionStorage.getItem("user.serviceBaseUrl") || createServiceBaseUrl()
  );
};
